import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Task, TaskService } from '../task.service';

@Component({
    selector: 'app-task-list-popup',
    templateUrl: './task-list-popup.component.html',
    styleUrls: ['./task-list-popup.component.scss'],
    standalone: false
})
export class TaskListPopupComponent implements OnInit {
  @Input() currentUrl = '';
  @Input() tasks: Task[];
  @Input() show: boolean;
  currentlySelectedTask = new Task();
  showEditTaskPopup:boolean;
  @Output() showChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute, private router: Router, private location: Location,
    private taskService: TaskService) { }

  ngOnInit() {
  }

  goToTasks(task) {
  this.currentlySelectedTask = new Task();
  this.taskService.getCoreTaskById(task.taskId).subscribe(result => {
    this.currentlySelectedTask = result;
    this.showEditTaskPopup = true;
  });

  }

  changePopupStatus() {
    this.showChange.emit(this.show);
  }

}
